<div class="card card-p" [ngClass]="{'gray-card-disable': !route}" [ngStyle]="{'max-width': setOwnCardWidth ? cardWidth : '216px'}" (click)="onClick()">
		<!-- [routerLink]="route" -->
  <img [src]="logoUrl" class="Process img-responsive icon-image-width icon-image-width">
  <div class="card-text">
    <p class="card-title ">{{title}}</p>
    <p class="continue-last-font">{{description}}</p>
  </div>
</div>


<!--Registration Modal:: begin-->
<div class="modal fade" id="m_modal_1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" style="display: none;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          Upload Excel File
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearForm()">
          <span aria-hidden="true">
            ×
          </span>
        </button>
      </div>
      <div class="modal-body">
        <form>
            <div class="form-group" [formGroup]="registrationForm">
              <div>
                <label>Sender Name</label>
                <input type="text" formControlName="senderName"/>
              </div>
              <div class="row">
                <div class="custom-file col-lg-4" style="margin-left: 15px;">
                  <input
                    type="file" class="custom-file-input" id="customFile"  formControlName="excelFile" (change)="onFileSelect($event)" (click)="onFileSelect($event)">
                  <label class="custom-file-label" for="customFile">
                    {{selectedFileName}}
                  </label>
                </div>
                <div *ngIf="role !== 'Ministry Admin'" class="col-lg-3">
                  <a href="https://nsdcuatpublic.s3.ap-south-1.amazonaws.com/temp/ExcelforReport.xlsx"
                    class="download-file-link">
                    Download Template
                  </a>
                </div>
                <div *ngIf="role === 'Ministry Admin'" class="col-lg-3">
                  <a class="download-file-link text-primary" (click)="downloadMinistryTemplate()">
                    Download Template
                  </a>
                </div>
              </div>
              <div class="row"
                [style.color]="(errorMessage === '(Allowed formats xlsx, xls)') ? 'blue' : 'red'">
                <div class="col-lg-8">
                  {{errorMessage}}
                </div>
              </div>
            </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" #closeModal class="btn btn-secondary" data-dismiss="modal" (click)="clearForm()">
          Close
        </button>
        <button type="button" class="btn btn-next" [disabled]="registrationForm.invalid" (click)="registerCandidate()">
          Upload
        </button>
      </div>
    </div>
  </div>
</div>